import SideBySideTitleParagraphComponent from "./side-by-side-title-paragraph-component";
import SideBySideTitleParagraphConfig from "./side-by-side-title-paragraph-config";
import SideBySideTitleParagraphAdvancedConfig from "./side-by-side-title-paragraph-advanced-config";

export default {
  SideBySideTitleParagraphComponent,
  SideBySideTitleParagraphConfig,
  SideBySideTitleParagraphAdvancedConfig
};
